import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControlName,
} from "@angular/forms";
import { sellPolicyData } from "../addpolicy/sellpolicyData.model";
import { DatastorageService } from "../datastorage.service";
import { AuthService } from "../core/auth/auth.service";
import { AppConfig } from "src/config/app.config";
import { Router } from "@angular/router";
import { Step } from "../core/step.model";
import * as moment from "moment";
import { NxDialogService, NxModalRef } from "@aposin/ng-aquila/modal";

@Component({
  selector: "app-plandetails",
  templateUrl: "./plandetails.component.html",
  styleUrls: ["./plandetails.component.css"],
})
export class PlandetailsComponent implements OnInit {
  public maxvehage: number;
  planDetailForm: FormGroup;
  sellPolicyData: sellPolicyData = new sellPolicyData();
  _apiUrl: string;
  clientId: number;
  planMasterList = [];
  test;
  expiryDate;
  effectiveDate;
  PolicyTerm: number;
  newEffectiveDate: Date;
  cessList: any;
  IsCess: boolean = false;
  step: Step = new Step();
  IsOffer: boolean;
  offerList: any;
  maxInsured: boolean = false;
  insuredplanYears: number;
  @ViewChild("policySearchModal") templateRef: TemplateRef<any>;
  templateDialogRef: NxModalRef<any>;
  originalExpiryDate: Date;
  originalEffectiveDate: Date; // Actual start date entered by user — preserved across plan switches

  constructor(
    private authService: AuthService,
    private appConfig: AppConfig,
    private dataService: DatastorageService,
    private router: Router,
    public dialogService: NxDialogService
  ) {
    this._apiUrl = appConfig.baseUrl;
    this.maxvehage = appConfig.maxvehicleAge;
    this.clientId = parseInt(atob(localStorage.getItem("CLIENT_ID")));
  }

  ngOnInit() {
    this.planDetailFormBuild();
    this.getPlanDetails();
    this.checkforDiscountedPlans();
    //this.getPlanMasterList();
    if (this.sellPolicyData.planId) {
      this.onPlanChanges(this.sellPolicyData.planId);
    }
    this.getCessandTaxesForState();
    this.initializeNav(1);
    this.getOffers();
  }

  initializeNav(compltedStep: number) {
    for (let i = 0; i <= compltedStep; i++) {
      this.step.stepNumber = i;
      this.step.completed = true;
      this.dataService.nextClick.next(this.step);
    }
  }

  checkforDiscountedPlans() {
    this.authService
      .get(this._apiUrl + `/api/v1/Plan/updatediscountapplicableplans`)
      .subscribe(
        (response) => {
          this.getPlanMasterList();
          //console.log(response);
        },
        (error) => {
          console.error(error);
        }
      );
  }
  getCessandTaxesForState() {
    this.authService.get(this._apiUrl + `/api/v1/CessTaxes/DealerId`).subscribe(
      (response) => {
        if (response.length > 0) {
          this.IsCess = true;
          this.cessList = response;
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  planDetailFormBuild() {
    this.planDetailForm = new FormBuilder().group({
      planId: [this.sellPolicyData.planId, Validators.required],
      policyName: this.sellPolicyData.policyName,
      price: this.sellPolicyData.price,
      gstPrice: this.sellPolicyData.gstPrice,
    });
  }

  getPlanMasterList() {
    this.authService.get(this._apiUrl + `/api/v1/Plan?pageNumber=-1`).subscribe(
      (response) => {
        if (response) {
          // Determine how many years of RSA coverage the vehicle has already consumed.
          // Two cases:
          //   A) Prior policy exists  → use originalExpiryDate vs vehicleSaleDate (anniversary-aligned)
          //   B) New policy (skipped years) → use effectiveDate vs vehicleSaleDate so the customer
          //      can pick the plan matching the year they are actually in, not year 1.
          let insuredYears = 0;
          let plancheckYears = 0;

          if (this.sellPolicyData.vehicleSaleDate) {
            const saleDate = new Date(this.sellPolicyData.vehicleSaleDate);

            if (this.originalExpiryDate) {
              // Case A: prior policy — count years from sale date to original expiry
              const diff = this.diffDate(saleDate, new Date(this.originalExpiryDate));
              insuredYears = diff.years + (diff.days > 0 ? 1 : 0);
              if(this.originalExpiryDate < new Date()){
              plancheckYears=insuredYears;
              }else{
                plancheckYears=insuredYears-1;
              }
            } else if (this.sellPolicyData.effectiveDate) {
              // Case B: no prior policy — count completed anniversary years up to coverage start
              const diff = this.diffDate(saleDate, new Date(this.sellPolicyData.effectiveDate));
              // diff.years = completed full years; this is the year index the new coverage starts in
              insuredYears = diff.years;
              plancheckYears=insuredYears;
            }
            this.insuredplanYears = insuredYears;
          }

           this.planMasterList = response.filter((plan) => {
            const maxAge = parseInt(plan.maximumVehicleAge);
            const duration = parseInt(plan.durationOfPlan);
            const minAge = maxAge - duration;
            // Upper bound: plan has not already ended for this vehicle.
            // Lower bound: plan starts at or before the vehicle's current year (prevents
            //   showing future-year plans and ensures skip-year enforcement).
            // Name check: plan name must not reference an already-covered year.
            let nameHasCoveredYear = plan.planName.includes(plancheckYears);
            if (plancheckYears >= 7) {
              nameHasCoveredYear = plan.planName.includes(4) || plan.planName.includes(5) || plan.planName.includes(6) || plan.planName.includes(7);
            } else if (plancheckYears >= 6) {
              nameHasCoveredYear = plan.planName.includes(4) || plan.planName.includes(5) || plan.planName.includes(6);
            } else if (plancheckYears >= 5) {
              nameHasCoveredYear = plan.planName.includes(4) || plan.planName.includes(5);
            }

            return maxAge > plancheckYears && !nameHasCoveredYear;
          });
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  savePlanDetails() {
    this.sellPolicyData.effectiveDate = this.effectiveDate;
    this.sellPolicyData.expiryDate = this.expiryDate;
    this.sellPolicyData.price = this.planDetailForm.get("price").value;
    this.sellPolicyData.gstPrice = this.planDetailForm.get("gstPrice").value;
    this.dataService.setData(this.sellPolicyData);
    this.router.navigate(["/sellpolicy/paymentdetails"]);

    this.step.stepNumber = 2;
    this.step.completed = true;
    this.dataService.nextClick.next(this.step);
  }

  getPlanDetails() {
    let resp = this.dataService.getData();
    if (resp) {
      this.sellPolicyData = this.dataService.getData();
      if (!this.sellPolicyData.originalExpiryDateForFiltering && this.sellPolicyData.expiryDate) {
        this.sellPolicyData.originalExpiryDateForFiltering = new Date(this.sellPolicyData.expiryDate);
      }
      this.originalExpiryDate = this.sellPolicyData.originalExpiryDateForFiltering;

      // Capture the actual policy start date once — used as the floor for start-date
      // calculation across all plan switches (so going back to 5th year always restores
      // the original effective date, not an anniversary date in the past).
      if (!this.originalEffectiveDate) {
        if (this.sellPolicyData.effectiveDate) {
          this.originalEffectiveDate = new Date(this.sellPolicyData.effectiveDate);
        } else {
          const today = new Date();
          this.originalEffectiveDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 2);
        }
      }

      this.planDetailFormBuild();
    }
  }

  getOffers() {
    this.authService
      .get(this._apiUrl + `/api/v1/ManageOffers/CheckForOffer`)
      .subscribe(
        (response) => {
          if (response) {
            this.IsOffer = true;
            this.offerList = response;
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }

  onPlanChanges(id) {
    this.authService.get(this._apiUrl + "/api/v1/Plan/" + id).subscribe(
      (response) => {
        if (response) {
          const gstPercentage = Math.round((parseInt(response.totalPrice) / 100) * 18);
          const durationOfPlan = parseInt(response.durationOfPlan);
          const maxAge = parseInt(response.maximumVehicleAge);
          this.PolicyTerm = durationOfPlan;

          if (this.sellPolicyData.vehicleSaleDate) {
            const saleDate = new Date(this.sellPolicyData.vehicleSaleDate);

            // End date: always the exact anniversary of vehicleSaleDate at maxAge years.
            // e.g. saleDate=27-07-2021, maxAge=6 → endDate=27-07-2027
            this.expiryDate = new Date(
              saleDate.getFullYear() + maxAge,
              saleDate.getMonth(),
              saleDate.getDate()
            );

            // Start date: anniversary of saleDate at (maxAge - duration) years,
            // but never earlier than the actual policy start date (originalEffectiveDate).
            // e.g. saleDate=27-07-2021, maxAge=5, duration=1
            //   anniversaryStart=27-07-2025, originalEffectiveDate=17-06-2026
            //   → effectiveDate=17-06-2026  (later of the two)
            // e.g. saleDate=27-07-2021, maxAge=6, duration=1
            //   anniversaryStart=27-07-2026, originalEffectiveDate=17-06-2026
            //   → effectiveDate=27-07-2026  (anniversary wins)
            const anniversaryStart = new Date(
              saleDate.getFullYear() + (maxAge - durationOfPlan),
              saleDate.getMonth(),
              saleDate.getDate()
            );
            const floor = this.originalEffectiveDate ?? new Date(this.sellPolicyData.effectiveDate);
            this.effectiveDate = anniversaryStart > floor ? anniversaryStart : floor;
          } else {
            // Fallback: no sale date available
            const floor = this.originalEffectiveDate ?? new Date();
            this.effectiveDate = floor;
            this.expiryDate = new Date(
              floor.getFullYear() + durationOfPlan,
              floor.getMonth(),
              floor.getDate()
            );
          }
          
          this.sellPolicyData.planId = response.planId;
          this.sellPolicyData.planIdentifier = response.identifier;
          this.sellPolicyData.policyName = response.planName;
          this.sellPolicyData.price = response.totalPrice;
          this.sellPolicyData.effectiveDate = this.effectiveDate;
          this.sellPolicyData.expiryDate = this.expiryDate;
          this.sellPolicyData.gstPrice = gstPercentage;
          this.planDetailFormBuild();
    
          if (this.IsOffer) {
            this.sellPolicyData.offerIdentifier = this.offerList.identifier;
            this.sellPolicyData.price =
              response.totalPrice -
              Math.round(
                (parseInt(response.totalPrice) / 100) *
                  this.offerList.discountPercent
              );
            //GST Calculated based on discounted price
            this.sellPolicyData.gstPrice = Math.round(
              (this.sellPolicyData.price / 100) * 18
            );
          }
          this.planDetailFormBuild();
        //Incase if a vehicle is exhausted with maximum policy renewal 
          let insuredyeardiff = this.diffDate(
            new Date(this.sellPolicyData.vehicleSaleDate),
            new Date(this.expiryDate)
          );
          let maxinsuredage = insuredyeardiff.years;
          if (maxinsuredage > this.maxvehage) {
            this.templateDialogRef = this.dialogService.open(this.templateRef, {
              ariaLabel: "Search dialoge",
            });
            this.maxInsured = true;
          }else{
            this.templateDialogRef?.close();
          } 
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  PrevPage() {
    this.step.stepNumber = 1;
    this.step.completed = false;
    this.dataService.nextClick.next(this.step);
  }

  closeModal(): void {
    this.planDetailForm.reset();
    this.templateDialogRef?.close();
  }

  diffDate(startDate, endDate): any {
    var b = moment(startDate),
      a = moment(endDate),
      out: any = {};
    let intervals: moment.unitOfTime.DurationConstructor[] = ["years", "days"];

    for (var i = 0; i < intervals.length; i++) {
      var diff = a.diff(b, intervals[i]);
      b.add(diff, intervals[i]);
      out[intervals[i]] = diff;
    }
    return out;
  }
}
